import { QuestionRequiredPrepMilli } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { useOptionRequiredPrepMillisecond } from "./hooks";

export const QuestionRoomRequiredPrepMillisecond = () => {
	const {
		requiredPrepMillisecondBeforeDate,
		onSetRequiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeDateOptions,

		requiredPrepMillisecondBeforeHour,
		onSetRequiredPrepMillisecondBeforeHour,
		requiredPrepMillisecondBeforeHourOptions,

		isEdited,
		hasError,
	} = useOptionRequiredPrepMillisecond();

	return (
		<QuestionRequiredPrepMilli
			isEdited={isEdited}
			hasError={hasError}
			requiredPrepMillisecondBeforeDate={requiredPrepMillisecondBeforeDate}
			requiredPrepMillisecondBeforeDateOptions={requiredPrepMillisecondBeforeDateOptions}
			onSetRequiredPrepMillisecondBeforeDate={onSetRequiredPrepMillisecondBeforeDate}
			requiredPrepMillisecondBeforeHour={requiredPrepMillisecondBeforeHour}
			requiredPrepMillisecondBeforeHourOptions={requiredPrepMillisecondBeforeHourOptions}
			onSetRequiredPrepMillisecondBeforeHour={onSetRequiredPrepMillisecondBeforeHour}
		/>
	);
};

QuestionRoomRequiredPrepMillisecond.displayName = "QuestionRoomRequiredPrepMillisecond";
